import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

export interface ObatDefaults {
  source: "personal" | "institusi" | "template" | "none";
  rute_id?: number;
  frekuensi_id?: number;
  ap_dosis?: string;
  ap_tambahan?: string;
  qty?: number;
  qty_unit?: string;
}

export interface RegimenItem {
  obat_id: string;
  obat_nama: string;
  qty: number;
  qty_unit: string;
  ap_dosis: string;
  ap_tambahan: string;
  rute_id: number | null;
  rute: { id: number; nama: string } | null;
  frekuensi_id: number | null;
  frekuensi: { id: number; nama: string } | null;
  r: string;
}

export interface Regimen {
  id: number;
  nama: string;
  text: string;
  user_id: number;
  items: RegimenItem[];
}

async function obatDefaults(obatId: string): Promise<ObatDefaults> {
  const response = await http
    .getData(`/resep-ralan-unified/obat/${encodeURIComponent(obatId)}/defaults`)
    .catch(err => {
      // Defaults are best-effort: don't alert on miss.
      return Promise.reject(err);
    });

  return response.data as ObatDefaults;
}

async function regimenFast(params: {
  q?: string;
  scope?: "personal" | "all";
}): Promise<Regimen[]> {
  const response = await http
    .getDataParam(`/resep-ralan-unified/regimen-fast`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data.data as Regimen[];
}

export default {
  obatDefaults,
  regimenFast
};
